import { useContext } from "react";
import { TransportContext } from "../context/TransportContext";

export const useTransportContext = () => {
  const context = useContext(TransportContext);

  if (!context) {
    throw new Error("useTransportContext moet binnen een TransportProvider worden gebruikt");
  }

  return context;
};
